import { render } from "./HelpFAQ.vue?vue&type=template&id=9652465c"
import script from "./HelpFAQ.vue?vue&type=script&lang=js"
export * from "./HelpFAQ.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__